import marketSubSectorsService from "@/services/market-sub-sectors.service";

export default {
    state: {
        subsectors: [],
    },
    actions: {
        async fetchSubsectors({commit, state}){
            if (state.subsectors.length) {
                return state.subsectors
            }

            const {data} = await marketSubSectorsService.getList();
            commit('setSubsectors', data);
        }
    },

    mutations: {
        setSubsectors(state, subsectors) {state.subsectors = subsectors}
    },

    getters: {
        subsectorsList: state => state.subsectors
    }
}
